<rap-functions-ui
  [functions]="functions$ | async"
  (deleteFunctionEmitter)="deleteFunction($event)"
  (editFunctionEmitter)="editFunction($event)"
></rap-functions-ui>
